import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';

export const saveNewAssignmentTypeOperation = async (
  assignmentTypeName: string,
  setLoading: (isLoading: boolean) => void,
  onHide: () => any,
) => {
  try {
    if (!assignmentTypeName && assignmentTypeName.length === 0) {
      toast.warn(`יש להזין את סוג המטלה`);
      console.warn(`Assignment type name must not be empty`);
      return;
    }
    if (assignmentTypeName && assignmentTypeName.length < 3) {
      toast.warn('על סוג המטלה להיות באורך של למעלה משלושה תווים');
    }

    const existingAssignment = globalSettingsStores.assignmentTypes.find(
      (item) => item.assignmentTypeName === assignmentTypeName,
    );
    if (existingAssignment) {
      toast.warn('שם מטלה כבר קיים במערכת');
      return;
    }
    setLoading(true);
    const res = await appApi.addAssignmentType(assignmentTypeName);
    if (res.data.ok && res.data.body) {
      globalSettingsStores.assignmentTypes.push(res.data.body);
      toast.success(`הוספת ${assignmentTypeName} התבצעה בהצלחה`);
    } else {
      toast.error(
        `יצירת סוג המטלה ${assignmentTypeName} נכשלה, נסה שוב בעוד מספר רגעים...`,
      );
    }
    setLoading(false);
    onHide();

    return;
  } catch (e) {
    toast.error('הוספת סוג מטלה נכשלה, נסה שוב בעוד מספר רגעים...');
    console.error(
      `saveNewAssignmentTypeOperation is failed with the assignment type: ${assignmentTypeName} and the error: ${e}`,
    );
  }
};
